import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { authRoutes } from './auth.routes';
import { CoreModule } from '../core/core.module';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';



@NgModule({
  declarations: [
    LoginComponent,
    ForgotPasswordComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(authRoutes),
    CoreModule,
    SharedModule    
  ],
  exports:[
    LoginComponent,
    ForgotPasswordComponent
  ]
})
export class AuthModule { }
